import { NoDocuments } from '@plato/ui-legacy/assets/icons/no-documents';
import Text from '@plato/ui-legacy/components/ui/text';
import { cn } from '@plato/ui/util/classes';
import type React from 'react';
import type { PropsWithChildren } from 'react';

function NoDocumentStateTitle({ children }: React.PropsWithChildren) {
    return (
        <Text weight={'bold'} size="sm">
            {children}
        </Text>
    );
}

function NoDocumentStateDescription({ children }: React.PropsWithChildren) {
    return <Text>{children}</Text>;
}

type NoDocumentStateProps = {
    className?: string;
    documentIcon?: React.ElementType;
} & PropsWithChildren;

export function NoDocumentState({ children, documentIcon, className }: NoDocumentStateProps) {
    const Icon = documentIcon || NoDocuments;

    return (
        <div className={cn('flex h-full flex-col', className)}>
            <div className="flex rounded-md border p-3">
                <div className="flex gap-3">
                    <Icon className="h-auto" />
                    <div className="flex flex-col gap-2 p-2">{children}</div>
                </div>
            </div>
        </div>
    );
}

NoDocumentState.Title = NoDocumentStateTitle;
NoDocumentState.Description = NoDocumentStateDescription;
